import isUndefined from 'lodash/isUndefined';
import omitBy from 'lodash/omitBy';
import { isMessengerTranslatedLanguage, } from 'components/settings/components/sections/dixaMessenger/views/appearance/components/generalSettings/languageSettings/languages';
const defaultAvailableLocales = ['en'];
const emptySettings = {
    backgroundColor: 'purple',
    title: {},
    description: {},
    startConversation: {},
    findArticles: {},
    bulletinBoardId: null,
    bulletinBoardEnabled: false,
    availableLocales: defaultAvailableLocales,
    defaultLanguage: defaultAvailableLocales[0],
    logo: undefined,
    launcherIconType: 'dixa-branded-default',
    minimumIdentificationLevel: 'ANONYMOUS',
};
export function formatFormValues(values = emptySettings, knowledgeState) {
    var _a;
    const baseSettings = {
        version: 2,
        style: {
            theme: {
                background: values.backgroundColor,
            },
            icon: values.launcherIconType === 'chat-bubbles'
                ? {
                    type: 'preset',
                    id: 'unbranded-default-icon',
                }
                : {
                    type: 'preset',
                    id: 'branded-dixa-icon',
                },
        },
        general: {
            title: values.title,
            description: values.description,
            startConversation: values.startConversation,
            findArticles: values.findArticles,
            availableLocales: putDefaultLanguageAsFirstItemInAvailableLocale(values.availableLocales || emptySettings.availableLocales, values.defaultLanguage),
            minimumIdentificationLevel: values.minimumIdentificationLevel,
            logo: values.logo
                ? {
                    type: 'fixed',
                    fixed: { fileId: values.logo },
                }
                : null,
        },
        integrations: {},
    };
    if (values.bulletinBoardId) {
        baseSettings.integrations = {
            bulletinBoard: {
                boardId: values.bulletinBoardId,
                enabled: (_a = values.bulletinBoardEnabled) !== null && _a !== void 0 ? _a : false,
            },
        };
    }
    return updateWithKnowledgeState(baseSettings, knowledgeState);
}
export function extractInitialValuesFromMessenger(messenger, fallbackSettings) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5;
    if (messenger === null) {
        return {};
    }
    const { settings } = messenger;
    const values = {
        title: Object.assign(Object.assign({}, (_a = fallbackSettings === null || fallbackSettings === void 0 ? void 0 : fallbackSettings.general) === null || _a === void 0 ? void 0 : _a.title), (((_b = settings === null || settings === void 0 ? void 0 : settings.general) === null || _b === void 0 ? void 0 : _b.title) || {})),
        description: Object.assign(Object.assign({}, (_c = fallbackSettings === null || fallbackSettings === void 0 ? void 0 : fallbackSettings.general) === null || _c === void 0 ? void 0 : _c.description), (((_d = settings === null || settings === void 0 ? void 0 : settings.general) === null || _d === void 0 ? void 0 : _d.description) || {})),
        startConversation: Object.assign(Object.assign({}, (_e = fallbackSettings === null || fallbackSettings === void 0 ? void 0 : fallbackSettings.general) === null || _e === void 0 ? void 0 : _e.startConversation), (((_f = settings === null || settings === void 0 ? void 0 : settings.general) === null || _f === void 0 ? void 0 : _f.startConversation) || {})),
        findArticles: Object.assign(Object.assign({}, (_g = fallbackSettings === null || fallbackSettings === void 0 ? void 0 : fallbackSettings.general) === null || _g === void 0 ? void 0 : _g.findArticles), (((_h = settings === null || settings === void 0 ? void 0 : settings.general) === null || _h === void 0 ? void 0 : _h.findArticles) || {})),
        backgroundColor: ((_k = (_j = settings === null || settings === void 0 ? void 0 : settings.style) === null || _j === void 0 ? void 0 : _j.theme) === null || _k === void 0 ? void 0 : _k.background) ||
            ((_m = (_l = fallbackSettings === null || fallbackSettings === void 0 ? void 0 : fallbackSettings.style) === null || _l === void 0 ? void 0 : _l.theme) === null || _m === void 0 ? void 0 : _m.background),
        bulletinBoardId: (_p = (_o = settings === null || settings === void 0 ? void 0 : settings.integrations) === null || _o === void 0 ? void 0 : _o.bulletinBoard) === null || _p === void 0 ? void 0 : _p.boardId,
        bulletinBoardEnabled: (_s = (_r = (_q = settings === null || settings === void 0 ? void 0 : settings.integrations) === null || _q === void 0 ? void 0 : _q.bulletinBoard) === null || _r === void 0 ? void 0 : _r.enabled) !== null && _s !== void 0 ? _s : false,
        availableLocales: filterOutUntranslatedLanguages(((_t = settings === null || settings === void 0 ? void 0 : settings.general) === null || _t === void 0 ? void 0 : _t.availableLocales) ||
            ((_u = fallbackSettings === null || fallbackSettings === void 0 ? void 0 : fallbackSettings.general) === null || _u === void 0 ? void 0 : _u.availableLocales)),
        defaultLanguage: (_w = filterOutUntranslatedLanguages((_v = settings === null || settings === void 0 ? void 0 : settings.general) === null || _v === void 0 ? void 0 : _v.availableLocales)[0]) !== null && _w !== void 0 ? _w : 'en',
        minimumIdentificationLevel: ((_x = settings === null || settings === void 0 ? void 0 : settings.general) === null || _x === void 0 ? void 0 : _x.minimumIdentificationLevel) ||
            ((_y = fallbackSettings === null || fallbackSettings === void 0 ? void 0 : fallbackSettings.general) === null || _y === void 0 ? void 0 : _y.minimumIdentificationLevel) ||
            'ANONYMOUS',
        logo: (_1 = (_0 = (_z = settings === null || settings === void 0 ? void 0 : settings.general) === null || _z === void 0 ? void 0 : _z.logo) === null || _0 === void 0 ? void 0 : _0.fixed) === null || _1 === void 0 ? void 0 : _1.fileId,
        launcherIconType: ((_3 = (_2 = settings === null || settings === void 0 ? void 0 : settings.style) === null || _2 === void 0 ? void 0 : _2.icon) === null || _3 === void 0 ? void 0 : _3.type) === 'preset' &&
            ((_5 = (_4 = settings === null || settings === void 0 ? void 0 : settings.style) === null || _4 === void 0 ? void 0 : _4.icon) === null || _5 === void 0 ? void 0 : _5.id) === 'unbranded-default-icon'
            ? 'chat-bubbles'
            : 'dixa-branded-default',
    };
    return omitBy(values, isUndefined);
}
function putDefaultLanguageAsFirstItemInAvailableLocale(availableLocales, defaultLanguage) {
    if (availableLocales.length === 0) {
        return [defaultLanguage];
    }
    if (availableLocales.length === 1) {
        return availableLocales;
    }
    // Use a `Set` to remove the potential duplicates
    return [...new Set([defaultLanguage, ...availableLocales])];
}
/**
 * There are some languages that are defined in the payloads library as a part
 * of the supported languages which are not yet translated on the widget side.
 * To keep the type system happy and prevent any potential bugs, this function
 * removes those untranslated languages from the list.
 */
export function filterOutUntranslatedLanguages(availableLocales = []) {
    return availableLocales.filter(isMessengerTranslatedLanguage);
}
function updateWithKnowledgeState(formattedValues, knowledgeState) {
    if (knowledgeState.isPristine === false) {
        if (knowledgeState.elevioIntegration.type === 'not-connected') {
            formattedValues.integrations.elevio = undefined;
        }
        else {
            formattedValues.integrations.elevio = {
                companyId: knowledgeState.elevioIntegration.companyId,
                enabled: knowledgeState.elevioIntegration.enabled,
                displayType: knowledgeState.elevioIntegration.displayType,
                searchBarPlaceholder: knowledgeState.elevioIntegration.translations.searchBarPlaceholder
                    .translatedMap,
            };
            formattedValues.general.findArticles =
                knowledgeState.elevioIntegration.translations.findArticles.translatedMap;
        }
    }
    return formattedValues;
}
